import { lazy, Suspense } from 'react';
import { useAuth } from '@/contexts/AuthContext';

// Defers loading the bell (and its supabase/popover/scroll-area deps)
// until we know the user is an admin. Non-admins never download this code.
const AdminNotificationBell = lazy(() => import('./AdminNotificationBell'));

export default function AdminNotificationBellLazy() {
  const { isAdmin } = useAuth();
  if (!isAdmin) return null;
  return (
    <Suspense fallback={null}>
      <AdminNotificationBell />
    </Suspense>
  );
}
